import React from 'react';
import { Link } from 'react-router-dom';
import { Grid } from '@mui/material';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { DataTableConfig } from '@/__configs/config_types';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { selectCurrentTableKey, selectDataTableAppliedSearchName } from '@/redux/selectors/dataTableSelectors';
import { dataTableInitialState } from '@/redux/selectors/configSelectors';
import { Breadcrumbs, Title, TitleBar } from '@/components/_common';

const DataTableTitleBar = ({ children }: { children?: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const tableName = useAppSelector(selectCurrentTableKey);
  const title = dataTableInitialState?.[tableName as keyof DataTableConfig]?.title;

  const onBreadcrumbClick = () => {
    dispatch(clearFilters(undefined));
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>{title}</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/orders" onClick={onBreadcrumbClick}>
              {title}
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}
        {children && children}
      </Grid>
    </TitleBar>
  );
};

export default DataTableTitleBar;
